module.exports = __webpack_public_path__ + "img/deepwater-outer-corner.02f98089.png";